import React, { useState } from "react";

//Order Process Pages
import ServiceNumberInformation from "./ServiceNumberInformation";
import CustomerRequirements from "./CustomerRequirements";
import TranslationNumbers from "./TranslationNumbers";
import PortingNumbers from "./PortingNumbers";
import UpdateOrder from "./UpdateOrder";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { gisRoutes } from "../../../../routes/routes";


import * as token from "../../../../helpers/token";
import { accountTypesConstants, portalFunctionalityConstants } from "../../../../constants";
import { initialState, submitValues, updateState, requirementsNeeded } from "../orderInput";

//Redux
import {
  serviceNumberTypeActions,
  customerActions,
  alertActions,
  orderActions
} from "actions";

//Components
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { ProgressTab } from "../../../../components/SkyFramework/ProgressTab/ProgressTab";

import { connect } from "react-redux";

// Constants
const phrasebook = phrasebookLoad();

class OrderAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(token.loggedProperty('customer_id'), this.props.match.params.id);


    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.handleCancellation = this.handleCancellation.bind(this);
  }

  componentDidMount() {
    this.setState({ step: 2 });
    if (this.props.match.params.id)
      this.props.dispatch(orderActions.get(this.props.match.params.id));
  }

  componentDidUpdate(prevProps) {

    if (this.props.order && prevProps && prevProps.order !== this.props.order) {
      this.setState(updateState(this.props.order));
      if (requirementsNeeded(this.props.order, this.props.order.servicenumbertypeorderhistory)) {
        this.setState({ step: 2 })
      } else {
        if (this.props.order.translation_number_required && ['numberrange', 'individual'].includes(this.props.order.translation_number_format)) {
          this.setState({ step: 3 })
        } else {
          if (this.props.order.porting) this.setState({ step: 4 })
          else this.setState({ step: 5 })
        }
      }
      this.setState({ terms_and_conditions: true });
    }
    if (this.props.uploaderror && prevProps && prevProps.uploaderror !== this.props.uploaderror) {
      this.setState({ [this.props.uploaderror]: undefined });
    }

  }

  calculateNextStep = (step) => {
    if (step === 1) {
      if (requirementsNeeded(this.state, this.state.selectedTypeNumber)) this.setState({ step: step + 1 })
      else if (this.state.translation_number_required && ['numberrange', 'individual'].includes(this.state.translation_number_format)) {
        this.setState({
          step: step + 2,
        });
      }
      else if (this.state.porting) {
        this.setState({
          step: step + 3,
        });
      }
      else {
        this.setState({
          step: step + 4,
        });
      }
    }
    else if (step === 2) {
      if (this.state.translation_number_required && ['numberrange', 'individual'].includes(this.state.translation_number_format)) {
        this.setState({
          step: step + 1,
        });
      }
      else if (this.state.porting) {
        this.setState({
          step: step + 2,
        });
      }
      else {
        this.setState({
          step: step + 3,
        });
      }
    }
    else if (step === 3) {
      if (this.state.porting) {
        this.setState({
          step: step + 1,
        });
      } else {
        this.setState({
          step: step + 2,
        });
      }
    }
    else {
      this.setState({
        step: step + 1,
      });
    }
  }

  // Proceed to next step
  nextStep = (e) => {
    e.preventDefault();
    const { step } = this.state;
    this.calculateNextStep(step);
  };


  // Go back to prev step
  prevStep = (e) => {
    e.preventDefault();
    const { value } = e.target;
    const { step } = this.state;
    if (step === 5) {
      if (this.state.porting) this.setState({
        step: step - 1,
      });
      else if (this.state.translation_number_required && ['numberrange', 'individual'].includes(this.state.translation_number_format)) this.setState({
        step: step - 2,
      });
      else if (this.state, requirementsNeeded(this.state, this.state.selectedTypeNumber)) this.setState({ step: step - 3 })
      else this.setState({
        step: step - 4,
      });
    } else if (step === 4) {
      if (this.state.translation_number_required && ['numberrange', 'individual'].includes(this.state.translation_number_format)) {
        this.setState({
          step: step - 1,
        });
      }
      else if (this.state, requirementsNeeded(this.state, this.state.selectedTypeNumber)) this.setState({ step: step - 2 })
      else this.setState({
        step: step - 3,
      });
    } else if (step === 3) {
      if (this.state, requirementsNeeded(this.state, this.state.selectedTypeNumber)) this.setState({ step: step - 1 })
      else this.setState({
        step: step - 2,
      });
    } else this.setState({
      step: step - 1,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    const { id } = e.target;
    this.setState({ status: id });
    var newValues = submitValues(this.state)
    newValues.status = id;
    this.props.dispatch(orderActions.update(this.state.id, newValues));
  }

  handleCancellation(e) {
    e.preventDefault();
    this.setState({ status: 'cancellation' });
    var newValues = submitValues(this.state)
    newValues.status = 'cancellation';
    this.props.dispatch(orderActions.update(this.state.id, newValues));
  }

  handleChange = (e) => {
    const { id, name, value, checked, type } = e.target;
    if (type === 'checkbox') {
      this.setState({ [id]: checked });
      if (id === 'translation_number_required') {
        if (checked) {
          if (['SIP Trunking', 'DID'].includes(this.state.service_type)) this.setState({ translation_number_type: '1to1' })
          else this.setState({ translation_number_type: '1tomany' })
          this.setState({ translation_number_required: checked })
        }
        else this.setState({
          translation_number_type: undefined,
          translation_number_format: 'e.164',
          translation_number_prefix: undefined,
          translation_number_to: undefined,
          translation_number_to_file: undefined,
        })
      }
      if (id === 'add_custom') {
        if (checked) {
          var custom = {
            nrc: undefined,
            mrc: undefined,
            fix_usage_rate: undefined,
            mobile_usage_rate: undefined,
            payphone_usage_rate: undefined,
            nrc_channel_charges: undefined,
            mrc_channel_charges: undefined,
            inbound_charges: undefined,
            outbound_charges_fixed: undefined,
            outbound_charges_mobile: undefined,
            currency: 'USD',
          };
          var keys = Object.keys(custom);
          keys.map(key => custom[key] = this.state.selectedTypeNumber.tariff[key])
          this.setState({ custom_tariff: custom })
        } else {
          this.setState({ custom_tariff: undefined })
        }
      }
    } else {
      if (id) {
        if (id === 'service_type') {
          this.setState({
            service_type: value,
            jurisdiction: undefined,
            cities: undefined,
            city: undefined
          });
          this.props.dispatch(serviceNumberTypeActions.getAllCoverage({ service_type: value }));
        }
        else if (id === 'jurisdiction' && ['SIP Trunking', 'DID'].includes(this.state.service_type)) {
          this.props.dispatch(serviceNumberTypeActions.getAllCoverageCities({ jurisdiction: value }));
          this.setState({ jurisdiction: value });
        } else if (id.includes('custom_')) {
          var custom_tariff = this.state.custom_tariff;
          custom_tariff[name] = value;
          this.setState({ custom_tariff: custom_tariff })
        } else {
          this.setState({ [id]: value });
        }
      }


      else if (name) this.setState({ [name]: value });
    }

  };

  saveChanges(e) {
    e.preventDefault();
    const { step } = this.state;
    this.setState({ ['status']: 'saved' });
    this.calculateNextStep(step);
    var newValues = submitValues(this.state);
    newValues.status = 'saved';
    this.props.dispatch(orderActions.update(this.state.id, newValues));
  }

  uploadFile(e) {
    const { id, files, accept } = e.target;
    var expectedfile;
    if (['end_user_address_proof', 'business_registration_doc', 'itu_assignment_doc', 'declaration_letter', 'portability_forms', 'portability_latest_invoices', 'portability_end_user_consent_letter'].includes(id)) expectedfile = ['pdf', 'doc', 'docx'];
    else if (['translation_number_to_file', 'porting_number_to_file'].includes(id)) expectedfile = ['xlsx'];
    else if (['authorised_person_passport_holding_photo_id', 'authorised_person_passport_id'].includes(id)) expectedfile = ['pdf', 'jpeg', 'png'];
    const file = files[0];
    if (file) {
      const allowedtypes = [];
      expectedfile.forEach(filetype => allowedtypes.push(portalFunctionalityConstants.documents[filetype]));
      if (allowedtypes.includes(file.type) && file !== null) {
        this.setState({ [id]: file.name })
        this.setState({ ['status']: 'saved' });
        this.props.dispatch(orderActions.uploadFile(file, id, expectedfile, this.state.order.id, this.state.customer_id));
        var newValues = submitValues(this.state)
        newValues[id] = file.name;
        newValues.status = 'saved';
        this.props.dispatch(orderActions.update(this.state.id, newValues));
      } else {
        this.props.dispatch(alertActions.error(`Please upload ${expectedfile.map(e => e).join("/")} file`))
      }
    }
  }

  downloadFile(e) {
    const { id, value, name } = e.target;
    e.preventDefault();
    if (name === 'template') this.props.dispatch(serviceNumberTypeActions.downloadFile(id, value));
    else if (name === 'requirement') this.props.dispatch(orderActions.downloadFile(value, id, this.state.order.id, this.state.customer_id));
  }


  render() {
    const { ...props } = this.state;
    if (this.state.order) {
      var tabs = [
        {
          step: 1,
          stepDescription: phrasebook.orders.detail_services,
          stepConditions: this.state.step === 1,
          stepPage: <ServiceNumberInformation
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            selectedTypeNumber={this.state.selectedTypeNumber}
          />,
          setState: { step: 1 },
          label: phrasebook.orders.product_features
        },

        {
          step: 5,
          stepDescription: phrasebook.orders.order_details,
          stepConditions: this.state.step === 5,
          stepPage: <UpdateOrder actualState={this.state}
            handleSubmit={this.handleSubmit}
            handleChange={this.handleChange}
            prevStep={this.prevStep}
            selectedTypeNumber={this.state.selectedTypeNumber}
            loggedAccount={token.loggedAccountType()}
            saveChanges={this.saveChanges}
          />,
          setState: { step: 5 },
          label: phrasebook.common.confirmation
        },
      ]

      if (this.state.porting) {
        tabs.splice(1, 0, {
          step: 4,
          stepDescription: phrasebook.orders.porting_inputs,
          stepConditions: this.state.step === 4,
          stepPage: <PortingNumbers
            actualState={this.state}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            saveChanges={this.saveChanges}
            loggedAccount={token.loggedAccountType()}
            handleChange={this.handleChange}
            uploadFile={this.uploadFile}
            downloadFile={this.downloadFile}
            selectedTypeNumber={this.state.selectedTypeNumber}
          />,
          setState: { step: 4 },
          label: phrasebook.orders.add_porting_required
        })
      }
      if (this.state.translation_number_required && ['numberrange', 'individual'].includes(this.state.translation_number_format)) {
        tabs.splice(1, 0, {
          step: 3,
          stepDescription: phrasebook.orders.translation_inputs,
          stepConditions: this.state.step === 3,
          stepPage: <TranslationNumbers
            actualState={this.state}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            saveChanges={this.saveChanges}
            loggedAccount={token.loggedAccountType()}
            handleChange={this.handleChange}
            uploadFile={this.uploadFile}
            downloadFile={this.downloadFile}
            selectedTypeNumber={this.state.selectedTypeNumber}
          />,
          setState: { step: 3 },
          label: phrasebook.orders.add_translation_required
        })
      }
      if (this.state, requirementsNeeded(this.state, this.state.selectedTypeNumber)) {
        tabs.splice(1, 0, {
          step: 2,
          stepDescription: phrasebook.orders.details_req,
          stepConditions: this.state.step === 2,
          stepPage: <CustomerRequirements
            actualState={this.state}
            saveChanges={this.saveChanges}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            loggedAccount={token.loggedAccountType()}
            uploadFile={this.uploadFile}
            downloadFile={this.downloadFile}
            handleChange={this.handleChange}
            selectedTypeNumber={this.state.selectedTypeNumber}
          />,
          setState: { step: 2 },
          label: phrasebook.orders.details_req
        })
      }
      if (['processed', 'accepted', 'assigned', 'ordered', 'testing', 'completed', 'cancellation', 'cancelled', 'terminated'].includes(this.state.order.status) || (this.state.order.status == 'ready' && token.loggedAccountType() >= 200)) return (<>
        <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.order.list, label: phrasebook.headerlinks.orders }]} current={`${phrasebook.common.edit} ${phrasebook.headerlinks.order}`} />
        <UpdateOrder actualState={this.state}
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          prevStep={this.prevStep}
          selectedTypeNumber={this.state.selectedTypeNumber}
          loggedAccount={token.loggedAccountType()}
          handleCancellation={this.handleCancellation}
        />
      </>)
      else return (
        <>
          <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.order.list, label: phrasebook.headerlinks.orders }]} current={`${phrasebook.common.edit} ${phrasebook.headerlinks.order}`} />
          <ProgressTab
            open={true}
            title={phrasebook.orders.update_order}
            tabs={tabs}
            actualState={this}
          />
        </>
      );
    } else return null
  }

}

function mapStateToProps(state) {
  const { authentication, order } = state;
  const { authUser } = authentication;
  return {
    authUser,
    order: order.order,
    uploaderror: order.uploaderror
  };
}

const ordering = connect(mapStateToProps)(OrderAdd);
export default ordering;
